import { Flex } from "@rebass/grid";
import {
  IContract,
  EContractIndexationStatus,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Button,
  Card,
  DisplayText,
  ESpacings,
  Icon,
  Stack,
} from "@rentiohq/web-shared/dist/components";
import { IChecklistItem } from "../ChecklistItem";
import * as S from "./IndexationCard.styled";

interface IProps {
  indexationItem: IChecklistItem;
  contract: IContract;
}

export const IndexationCard = ({ indexationItem, contract }: IProps) => {
  const canIndex =
    contract.indexationStatus &&
    [
      EContractIndexationStatus.Ready,
      EContractIndexationStatus.OwnerAsked,
      EContractIndexationStatus.OwnerApproved,
    ].includes(contract.indexationStatus);
  return (
    <Card.Section
      boxProps={{
        px: ESpacings.loose,
        py: ESpacings.base,
      }}
    >
      <DisplayText size="extraSmall">
        {getLocalizedText("property.indexation_possible.label")}
      </DisplayText>
      <S.Wrapper onClick={canIndex ? indexationItem?.onClick : undefined}>
        <Flex justifyContent="space-between" alignItems="center">
          <Stack spacing="tight" alignment="center">
            <Icon source="currencyEuroIncrease" />
            <S.TaskTitle>
              {getLocalizedText(
                `property.dashboard.checklist.index_contract.${contract.indexationStatus}.content`.toLowerCase(),
              )}
            </S.TaskTitle>
          </Stack>
          {canIndex && (
            <Button size="small" color="primary">
              {`${getLocalizedText("system.start")} ›`}
            </Button>
          )}
        </Flex>
      </S.Wrapper>
    </Card.Section>
  );
};
